<template>
  <div id="faq">
    <div v-if="faqData !== null && !isAFRIVERSE">
      <div class="faq_container">
        <h1>{{ replaceText(faqData.title) }}</h1>
        <div class="faq_details_container">
          <div class="faq_details">
            <h3>{{ replaceText(faqData.ques1) }}</h3>
            <span>{{ replaceText(faqData.ans1) }}</span>
          </div>
          <div class="faq_details">
            <h3>{{ replaceText(faqData.ques2) }}</h3>
            <span>{{ replaceText(faqData.ans2) }}</span>
          </div>
          <div class="faq_details">
            <h3>{{ replaceText(faqData.ques3) }}</h3>
            <span>{{ replaceText(faqData.ans3) }}</span>
          </div>
          <div class="faq_details">
            <h3>{{ replaceText(faqData.ques4) }}</h3>
            <span>{{ replaceText(faqData.ans4) }}</span>
          </div>
          <div class="faq_details">
            <h3>{{ replaceText(faqData.ques5) }}</h3>
            <span>{{ replaceText(faqData.ans5) }}</span>
          </div>
          <!--
          <div class="faq_details">
            <h3>{{ replaceText(faqData.ques6) }}</h3>
            <span>{{ replaceText(faqData.ans6) }}</span>
          </div>
          -->
          <div class="faq_details">
            <h3>{{ replaceText(faqData.ques7) }}</h3>
            <span>{{ replaceText(faqData.ans7) }}</span>
          </div>
          <div class="faq_details">
            <h3>{{ replaceText(faqData.ques8) }}</h3>
            <span>{{ replaceText(faqData.ans8) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isAFRIVERSE">
      <div class="faq_container">
        <h1>{{ replaceText(faqData.title) }}</h1>
        <div class="faq_details_container">
          <h2>{{ replaceText(faqData.abouttitle) }}</h2>
          <div class="faq_details">
            <h3>{{ replaceText(faqData.ques1) }}</h3>
            <span>{{ replaceText(faqData.ans1) }}</span>
          </div>
          <div class="faq_details">
            <h3>{{ replaceText(faqData.ques2) }}</h3>
            <span>{{ replaceText(faqData.ans2) }}</span>
          </div>
          <div class="faq_details">
            <h3>{{ replaceText(faqData.ques3) }}</h3>
            <span>{{ replaceText(faqData.ans3) }}</span>
          </div>
          <h2>{{ replaceText(faqData.substitle) }}</h2>
          <div class="faq_details">
            <h3>{{ replaceText(faqData.ques4) }}</h3>
            <span>{{ replaceText(faqData.ans4[0]) }}</span>
            <h4>{{ replaceText(faqData.ans4[1]) }}</h4>
            <ul>
              <li><span>{{ replaceText(faqData.ans4[2]) }}</span></li>
            </ul>
            <h4>{{ replaceText(faqData.ans4[3]) }}</h4>
            <ul>
              <li><span>{{ replaceText(faqData.ans4[4]) }}</span></li>
              <li><span>{{ replaceText(faqData.ans4[5]) }}</span></li>
            </ul>
            <span>{{ replaceText(faqData.ans4[6]) }}</span>
          </div>
          <div class="faq_details">
            <h3>{{ replaceText(faqData.ques5) }}</h3>
            <span>{{ replaceText(faqData.ans5[0]) }}</span>
            <ul>
              <li><span>{{ replaceText(faqData.ans5[1]) }}</span></li>
              <li><span>{{ replaceText(faqData.ans5[2]) }}</span></li>
            </ul>
            <span>{{ replaceText(faqData.ans5[3]) }}</span>
          </div>
          <div class="faq_details">
            <h3>{{ replaceText(faqData.ques6) }}</h3>
            <span>{{ replaceText(faqData.ans6) }}</span>
          </div>
          <div class="faq_details">
            <h3>{{ replaceText(faqData.ques7) }}</h3>
            <span>{{ replaceText(faqData.ans7) }}</span>
          </div>
          <h2>{{ replaceText(faqData.unsubtitle) }}</h2>
          <div class="faq_details">
            <h3>{{ replaceText(faqData.ques8) }}</h3>
            <span>{{ replaceText(faqData.ans8[0]) }}</span>
            <h4>{{ replaceText(faqData.ans8[1]) }}</h4>
            <ul>
              <li><span>{{ replaceText(faqData.ans8[2]) }}</span></li>
            </ul>
            <h4>{{ replaceText(faqData.ans8[3]) }}</h4>
            <ul>
              <li><span>{{ replaceText(faqData.ans8[4]) }}</span></li>
            </ul>
            <h4>{{ replaceText(faqData.ans8[5]) }}</h4>
            <ul>
              <li><span>{{ replaceText(faqData.ans8[6]) }}</span></li>
              <li><span>{{ replaceText(faqData.ans8[7]) }}</span></li>
            </ul>
            <span>{{ replaceText(faqData.ans8[8]) }}</span>
          </div>
          <h2>{{ replaceText(faqData.contenttitle) }}</h2>
          <div class="faq_details">
            <h3>{{ replaceText(faqData.ques9) }}</h3>
            <span>{{ replaceText(faqData.ans9[0]) }}</span>
            <ul>
              <li><span>{{ replaceText(faqData.ans9[1]) }}</span></li>
              <li><span>{{ replaceText(faqData.ans9[2]) }}</span></li>
              <li><span>{{ replaceText(faqData.ans9[3]) }}</span></li>
            </ul>
            <span>{{ replaceText(faqData.ans9[4]) }}</span>
          </div>
          <div class="faq_details">
            <h3>{{ replaceText(faqData.ques10) }}</h3>
            <span>{{ replaceText(faqData.ans10) }}</span>
          </div>
          <h2>{{ replaceText(faqData.privacytitle) }}</h2>
          <div class="faq_details">
            <h3>{{ replaceText(faqData.ques11) }}</h3>
            <span>{{ replaceText(faqData.ans11[0]) }}</span>
            <span>{{ replaceText(faqData.ans11[1]) }}</span>
          </div>
          <h2>{{ replaceText(faqData.custtitle) }}</h2>
          <div class="faq_details">
            <h3>{{ replaceText(faqData.ques12) }}</h3>
            <span>{{ replaceText(faqData.ans12[0]) }}</span>
            <span>{{ replaceText(faqData.ans12[1]) }}</span>
            <span>{{ replaceText(faqData.ans12[2]) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { waitForLoaderToHide } from "../../aframe/utils/scene.utils";
import { getFaqText } from "../helpers/faq-page-data.helper";
import { replaceText } from "../helpers/domain-text-config";
import { isAFRIVERSE } from "../utils/isMobioVr.utils";

export default {
  methods: {
    replaceText,
  },

  async created() {
    waitForLoaderToHide();
    this.faqData = await getFaqText();
  },
  async mounted() {
    this.faqData = await getFaqText();
  },
  data: () => ({
    faqData: null,
    isAFRIVERSE,
    Data: null,
  }),
};
</script>

<style lang="scss">
.faq_container {
  background-color: #efefef;
  cursor: auto;
  padding: 25px 30px;
  color: #3a3a3a;
  font-family: "Helvetica Neue";

  .faq_details_container {
    margin-bottom: 10%;
  }

  h1 {
    font-size: 22px;
    line-height: 23px;
    margin-bottom: 5px;
    color: #3f3f3f;
    text-align: center;
    margin-top: 3%;
  }
  h3 {
    font-size: 17px;
    font-weight: bold;
    line-height: 21px;
    padding-top: 21px;
    color: #3f3f3f;
  }
  span {
    font-size: 13px;
    font-weight: normal;
    line-height: 19px;
    margin: 0;
    padding: 0;
  }
}

@media screen and (max-width: 600px) {
  .faq_container {
    margin-bottom: 20%;
    h1 {
      margin-top: 55px;
    }
    .faq_details_container {
      margin-bottom: 21%;
    }
  }
}
@media screen and (max-width: 1024px) and (orientation: landscape) {
  .faq_container {
    .faq_details_container {
      margin-bottom: 15%;
    }
    h1 {
      margin-top: 6%;
    }
  }
}
@media screen and (max-width: 853px) and (orientation: landscape) {
  .faq_container {
    .faq_details_container {
      margin-bottom: 19%;
    }
  }
}
</style>
